import { render, staticRenderFns } from "./WpStep1.vue?vue&type=template&id=589d8f8e&"
import script from "./WpStep1.vue?vue&type=script&lang=js&"
export * from "./WpStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports